import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService, ValidatorService, AdministrationService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { SavePermissionRequest, User } from '../../../../models';
import { Utils } from '../../../../utils';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-validators-config-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.css']
})

export class ValidatorsConfigPermissionComponent implements OnInit, OnDestroy {

  sub: any;
  id: any;
  permissions = [];
  users = [];
  checkedUsers = [];

  constructor(
    private route: ActivatedRoute,
    private administrationService: AdministrationService,
    private validatorService: ValidatorService,
    private utils: Utils,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
      if (!this.id) { return; }
      this.initPermissions();
    });
  }

  initPermissions(): void {
    this.administrationService.getAllUsers(true)
      .subscribe(users => {
        this.users = users;
        this.validatorService.getAllValidationConfigsPermissions(this.id)
          .subscribe(permissions => {
            this.permissions = permissions;
            this.checkedUsers = permissions.map(p => p.id);
          });
      });
  }

  success = false;
  failed = false;
  synchtab = [];

  displayMessage() {
    if (this.success && !this.failed) {
      this.messageService.add({ severity: 'success', summary: 'Zapisano uprawnienia', detail: 'Zmieniono uprawnienia do konfiguracji walidacji użytkownikom.' })
    }
    else if (this.success && this.failed) {
      this.messageService.add({ severity: 'warn', summary: 'Zapisano część uprawnień', detail: 'Zmieniono uprawnienia do konfiguracji części użytkowników.' })
    }
    else if (!this.success && this.failed) {
      this.messageService.add({ severity: 'error', summary: 'Błąd podczas zapisu uprawnień', detail: 'Wystąpiły błędy podczas zmiany uprawnień do konfiguracji walidacji.' })
    }
    else {
      this.messageService.add({ severity: 'info', summary: 'Brak zmian', detail: 'Brak zmian uprawnień.' })
    }
  }

  applyPermissions() {
    this.success = false;
    this.failed = false;

    if (!(this.permissions && this.permissions.some(user => !this.checkedUsers.includes(user.id))) &&
      !(this.checkedUsers.some(idUser => !this.permissions || !this.permissions.map(p => p.id).includes(idUser)))) {
      this.displayMessage();
      return;
    }
    if (this.permissions && this.permissions.length > 0) {
        this.permissions.filter(user => !this.checkedUsers.includes(user.id))
          .forEach(user => {
            this.synchtab.push(user);
            this.validatorService.removePermission(user.id, this.id).subscribe(
              () => {
                console.log('Permission removed for id user ' + user.id);
                const idx = this.permissions.findIndex(u => u.id === user.id);
                if (idx !== -1) {
                  this.permissions.splice(idx, 1);
                }
                this.success = true;
                this.synchtab.pop();
                if (this.synchtab.length === 0) {
                  this.displayMessage();
                }
              },
              error => {
                this.failed = true;
                this.synchtab.pop();
                if (this.synchtab.length === 0) {
                  this.displayMessage();
                }
              }
            );
          })
    }
    this.users.filter(user => this.checkedUsers.includes(user.id) && (!this.permissions || !this.permissions.map(p => p.id).includes(user.id)))
      .forEach(user => {
        this.synchtab.push(user);
        this.validatorService.addPermission(user.id, this.id).subscribe(
          () => {
            console.log('Permission granted for id user ' + user.id);
            this.permissions.push(user);
            this.success = true;
            this.synchtab.pop();
            if (this.synchtab.length === 0) {
              this.displayMessage();
            }
          },
          error => {
            this.failed = true;
            this.synchtab.pop();
            if (this.synchtab.length === 0) {
              this.displayMessage();
            }
          }
        );
      });
  }

  save(): void {
    this.applyPermissions();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
